'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = ['M48 160l0 256c0 8.8 7.2 16 16 16l48 0 0-288-48 0c-8.8 0-16 7.2-16 16zm112-16l0 288 192 0 0-288-192 0zm240 0l0 288 48 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-48 0z', 'M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zm24 88l184 0 0 288-192 0 0-288 8 0zm-56 0l0 288-48 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l48 0zM400 432l0-288 48 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSuitcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;